export const required = (v: string): string | boolean =>
  !!v || "Campo obbligatorio";

export const email = (v: string): string | boolean =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
  "L'email deve essere valida";

export const selectMulti = (v: unknown[]): string | boolean =>
  v.length > 0 || "Almeno una scelta è obbligatoria";

export const sixElements = (v: string): string | boolean =>
  /^[a-zA-Z0-9]{6,}$/.test(v) || "Servono sei caratteri";
